import React, { useEffect, useState } from "react";
import CreatePage from "../../controls/CreatePage";
import { getKOT, updateKOTStatus } from "../../../api/KOTApi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import NoDataFound from "../../controls/NoDataFound";
import Loading from "../../controls/Loading";
import Button from "../../controls/Button";
import { useNavigate } from "react-router-dom";

const KDS = () => {
  const store = useSelector((state) => state.store.store);
  const navigate=useNavigate();

  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  const [selectedOption, setSelectedOption] = useState("Pending");

  const options = ["Pending", "Ready", "Completed"];

  const fetchOrders = async (option,hideLoading=false) => {
    try {
      if(!hideLoading){
        setLoading(true);
      }
      let response = await getKOT(store?.key, option);

      if (response.code === "0") {
        setOrders(response?.orders || []);
      } else {
        toast.error(response?.message || "Failed to load orders");
        setOrders([]);
      }
    } catch (error) {
      toast.error(error?.message || "Failed to load orders");
      setOrders([]);
    } finally {
        if(!hideLoading){
        setLoading(false);
      }
    }
  };

  const handleStatusUpdate = async (key, newStatus) => {
    try {
        setLoading(true);
      let response = await updateKOTStatus(key, newStatus);
      if (response.code === "0") {
        toast.success("Status Updated");
        setLoading(false);
        fetchOrders(selectedOption,false);
      } else {
        setLoading(false);
        toast.error(response.message);
      }
    } catch (error) {
        setLoading(false);
      toast.error("Failed to update status");
    }
  };

//   useEffect(() => {
//     if (store?.key) {
//       fetchOrders(selectedOption);
//     }
//   }, [selectedOption, store]);
useEffect(() => {
  if (!store?.key) return;

  // Initial fetch
  fetchOrders(selectedOption,false);

  // Poll orders every 10 seconds
  const intervalId = setInterval(() => {
    fetchOrders(selectedOption,true);
  }, 10000);

  // Cleanup on unmount
  return () => clearInterval(intervalId);

}, [store, selectedOption]);

  return (
    <CreatePage handleCancel={()=>{navigate(-1)}} showFooter={false} title="KOT - Kitchen Display">
      <div className="p-4 bg-gray-100 min-h-screen">

        {/* FILTER BUTTONS */}
        <div className="flex gap-4 mb-6">
          {options.map((opt) => (
            <button
              key={opt}
              onClick={() => setSelectedOption(opt)}
              className={`px-6 py-2 rounded-lg font-semibold text-lg transition 
                ${
                  selectedOption === opt
                    ? "bg-blue-600 text-white"
                    : "bg-white border border-gray-300"
                }`}
            >
              {opt}
            </button>
          ))}
        </div>

        {/* LOADING */}
        {loading && (
         <Loading/>
        )}

        {/* NO DATA */}
        {!loading && orders.length === 0 && (
          <NoDataFound
            message="No orders found for selected filter"
            isFullScreen={false}
          />
        )}

        {/* KOT GRID */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {orders.map((m, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg border border-gray-200 flex flex-col"
            >
              {/* HEADER */}
              <div className="bg-gray-800 text-white p-4 rounded-t-2xl">
                <div className="flex justify-between items-center">
                  <div className="text-2xl font-bold">
                    KOT: {m.KOTNo}
                  </div>
                  <div className="text-sm">
                                                    {new Date(m.TransactionDate._seconds * 1000).toLocaleString('en-US', { timeZone: "Asia/Kolkata", hour: 'numeric', minute: 'numeric', hour12: true })}
                                                
                  </div>
                </div>

                <div className="flex gap-2 mt-2 text-sm">
                  {m.RequestSource && (
                    <span className="bg-yellow-500 px-2 py-1 rounded">
                      {m.RequestSource}
                    </span>
                  )}
                  {m.KOTType && (
                    <span className="bg-green-600 px-2 py-1 rounded">
                      {m.KOTType}
                    </span>
                  )}
                  {m.TransactionNo && (
                    <span className="bg-blue-600 px-2 py-1 rounded">
                      {m.TransactionNo}
                    </span>
                  )}
                </div>
              </div>

              {/* BODY */}
              <div className="p-4 flex-1 overflow-auto max-h-[300px]">
                {m.LineItems.map((l, i) => (
                  <div
                    key={i}
                    className=" py-2 flex justify-between"
                  >
                    <div>
                      <div className="font-semibold text-lg">
                        {l.Product.Name}
                      </div>

                      {l.Modifiers?.length > 0 && (
                        <div className="text-sm italic text-gray-600">
                          {l.Modifiers.map((p) => p.ModifierName).join(", ")}
                        </div>
                      )}

                      {l.Notes && (
                        <div className="text-sm italic text-red-500">
                          {l.Notes}
                        </div>
                      )}
                    </div>

                    <div className="text-xl font-bold">
                      {l.Qty}
                    </div>
                  </div>
                ))}
              </div>

              {/* FOOTER */}
              <div className="p-4 border-t text-center">
                {m.Status === "Pending" && (
                    <Button
                      showFullWidth={true}
                     onClick={() =>
                      handleStatusUpdate(m.key, "Ready")
                    }
                    >
                         Ready
                    </Button>
                
                )}

                {m.Status === "Ready" && (
                       <Button
                         showFullWidth={true}
                     onClick={() =>
                       handleStatusUpdate(m.key, "Completed")
                    }
                    >
                          Served
                    </Button>
                )}

                {m.Status === "Completed" && (
                  <span className="text-green-700 font-bold text-lg">
                    Completed
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </CreatePage>
  );
};

export default KDS;